export default __webpack_public_path__ + "static/media/trend-black.4dfad204.svg";